import React, { useState } from 'react'
import './form-code-verification.scss'
import InputWebinar from '../../atoms/input-webinar/input-webinar'
import WebinarService from '../../../shared/services/webinar'
import Loader from 'react-loader-spinner'

const FormCodeVerification = props => {
    const { isPY, pyInfo, setstepState, setuserInfoPreload } = props

    const EMAIL_RX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

    const [optionSelected, setoptionSelected] = useState(null)
    // const [optionSelected, setoptionSelected] = useState('email')

    const [isLoading, setisLoading] = useState(false)

    const [email, setemail] = useState('')
    const [phone, setphone] = useState('')

    const [code1, setcode1] = useState('')
    const [code2, setcode2] = useState('')
    const [code3, setcode3] = useState('')
    const [code4, setcode4] = useState('')
    const [code5, setcode5] = useState('')
    const [code6, setcode6] = useState('')
    const [codeError, setcodeError] = useState(false)

    const settersCodeList = [setcode1, setcode2, setcode3, setcode4, setcode5, setcode6]

    const [inputError, setinputError] = useState(false)

    const [codeSendend, setcodeSendend] = useState(false)
    // const [codeSendend, setcodeSendend] = useState(true)

    const handleChangeOption = value => {
        setoptionSelected(value)
        setinputError(false)
        setemail('')
        setphone('')
        setcodeSendend(false)
        setcode1('')
        setcode2('')
        setcode3('')
        setcode4('')
        setcode5('')
        setcode6('')
        setcodeError(false)
    }

    const haveErrors = () => {

        if (optionSelected === 'sms') {

            if (!phone) {
                setinputError('Debes llenar este campo')
            } else {
                if (!phone.match(/^\+?\d*$/) || phone.length !== parseInt(process.env.CELL_DIG)) {
                    setinputError('Número inválido')
                } else {
                    setinputError(false)
                }
            }
        } else {

            if (!email) {
                setinputError('Debes llenar este campo')
            } else {
                if (!email.match(EMAIL_RX)) {
                    setinputError('El correo no es válido')
                } else {
                    setinputError(false)
                }
            }
        }

        return (optionSelected === 'sms' ?
            (!phone ? true : (!phone.match(/^\+?\d*$/) || phone.length !== parseInt(process.env.CELL_DIG)))
            :
            (!email ? true : (!email.match(EMAIL_RX)))
        )
    }

    const handlePayCode = () => {
        if (!haveErrors()) {
            setisLoading(true)
            let payload = {
                verificationMethod: optionSelected === 'sms' ? 'SMS' : 'EMAIL',
                value: optionSelected === 'sms' ?
                    isPY ?
                        pyInfo.COUNTRY_PHONE_PREFIX + phone
                        :
                        process.env.COUNTRY_PHONE_PREFIX + phone
                    :
                    email,
            }

            WebinarService.payOTP(payload).then(res => {
                setisLoading(false)
                if (res.status === 200) {
                    setcodeSendend(true)
                } else if (res.status === 400) {
                    setinputError(res.userMessage)
                } else {
                    console.log(res);
                }
            })
        }
    }

    const handleCodeChange = (e, index) => {
        let setterCode = settersCodeList[index]
        if (!e.target.value.match(/[^A-Za-z0-9]+/)) {
            setterCode(e.target.value.toUpperCase().slice(0, 1))
        }
    }

    const handleKeyDown = e => {
        const form = e.target.form;
        const index = Array.prototype.indexOf.call(form, e.target);
        if (e.keyCode === 8) {
            if (index !== 0) {
                form.elements[index - 1].focus();
            }
        } 
        else if ((e.keyCode >= 48 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105)) {
            if (index !== 5 && !e.key.match(/[^A-Za-z0-9]+/)) {
                form.elements[index + 1].focus();
            }
        }
        e.preventDefault();
    }

    const handleCodeVerification = () => {
        setisLoading(true)
        setcodeError(false)
        let resultCode = code1 + code2 + code3 + code4 + code5 + code6
        let resultUser = optionSelected === 'sms' ?
            isPY ?
                '%2B' + (pyInfo.COUNTRY_PHONE_PREFIX).slice(1, pyInfo.COUNTRY_PHONE_PREFIX.length) + phone
                :
                '%2B' + (process.env.COUNTRY_PHONE_PREFIX).slice(1, process.env.COUNTRY_PHONE_PREFIX.length) + phone
            :
            email
        WebinarService.validateOTP(resultCode, resultUser).then(res => {
            setisLoading(false)
            if (res.status === 200) {
                res.data.verificationMode = optionSelected === 'sms' ? 'SMS' : 'EMAIL'
                setuserInfoPreload(res.data)
                setTimeout(() => {
                    setstepState('stepLoyaltyForm')
                }, 100);
            } else if (res.status === 400) {
                setcodeError(res.userMessage)
            } else {
                console.log(res)
            }
        })

    }

    return (
        <div className="f-webinar-code-verification">
            <div className="f-webinar-form-row">
                <div className="f-webinar-option-label">
                    Elige una opción para verificar tu cuenta:
                </div>
                <button className={"f-button-option " + (optionSelected === 'email' ? "active" : "")} onClick={() => handleChangeOption('email')}>
                    Email
                </button>
                <button className={"f-button-option " + (optionSelected === 'sms' ? "active" : "")} onClick={() => handleChangeOption('sms')}>
                    Celular
                </button>
            </div>

            {!optionSelected ?
                null
                :
                <>
                    {
                        optionSelected === 'email' ?
                            <InputWebinar
                                label="Email"
                                placeholder='ejemplo@mail.com'
                                error={inputError}
                                value={email}
                                onChange={e => setemail(e.replace(/ /g, ''))}
                            />
                            :
                            <InputWebinar
                                label="Celular"
                                placeholder={'Ej: ' + '3003984754'.slice(0, process.env.CELL_DIG)}
                                error={inputError}
                                value={phone}
                                onChange={e => setphone(e.replace(/ /g, '').slice(0, process.env.CELL_DIG))}
                            />
                    }

                    {!codeSendend ?
                        !isLoading ?
                            <button className="f-leaflet-form-submit" onClick={() => handlePayCode()}>
                                SIGUIENTE
                            </button>
                            :
                            <div className="f-loader-container">
                                <Loader
                                    type="Oval"
                                    color="#003784"
                                    height={50}
                                    width={50}
                                />
                            </div>

                        :
                        <>

                            <div className="f-webinar-form-row">
                                <div className="f-webinar-option-label">
                                    Verificación tu cuenta
                                </div>
                                <div className="f-webinar-sub-label">
                                    Recuerda que hemos enviado <b>un código de 6 dígitos</b>
                                </div>
                            </div>
                            <form className="f-code-form">
                                <input className={"f-code-input " + (codeError ? 'error' : '')} type="text" value={code1} onChange={e => handleCodeChange(e, 0)} onKeyUp={handleKeyDown} />
                                <input className={"f-code-input " + (codeError ? 'error' : '')} type="text" value={code2} onChange={e => handleCodeChange(e, 1)} onKeyUp={handleKeyDown} />
                                <input className={"f-code-input " + (codeError ? 'error' : '')} type="text" value={code3} onChange={e => handleCodeChange(e, 2)} onKeyUp={handleKeyDown} />
                                <input className={"f-code-input " + (codeError ? 'error' : '')} type="text" value={code4} onChange={e => handleCodeChange(e, 3)} onKeyUp={handleKeyDown} />
                                <input className={"f-code-input " + (codeError ? 'error' : '')} type="text" value={code5} onChange={e => handleCodeChange(e, 4)} onKeyUp={handleKeyDown} />
                                <input className={"f-code-input " + (codeError ? 'error' : '')} type="text" value={code6} onChange={e => handleCodeChange(e, 5)} onKeyUp={handleKeyDown} />
                            </form>
                            {codeError && <div className="f-code-error">{codeError}</div>}
                            {!isLoading ?
                                <button className="f-leaflet-form-submit f-code-verification-send" onClick={() => handleCodeVerification()}>
                                    ENVIAR
                                </button>
                                :
                                <div className="f-loader-container">
                                    <Loader
                                        type="Oval"
                                        color="#003784"
                                        height={50}
                                        width={50}
                                    />
                                </div>
                            }
                        </>
                    }
                </>
            }
        </div>
    )
}

export default FormCodeVerification
